const { h, Component } = require('preact');
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const CommentBox = require('./comment_box');

class FeedbackForm extends Component {
  constructor(props) {
    super(props);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleExitFromModal = this.handleExitFromModal.bind(this);
    this.handleCommentInput = this.handleCommentInput.bind(this);
    this.showCommentBox = this.showCommentBox.bind(this);
  }

  showCommentBox(e) {
    const { value } = e.target;
    let showCommentBox = Groupon.Utils.getConfigFromDom().isFeedbackTextEnabled;
    let commentBoxPlaceholder;
    switch(value) {
      case "1":
      case "2":
        commentBoxPlaceholder = I18n.translate('js.modules.web_2018.feedback.comment_box_header_1');
      break;
      case "3":
      case "4":
        commentBoxPlaceholder = I18n.translate('js.modules.web_2018.feedback.comment_box_header_2');
      break;
      case "5":
        commentBoxPlaceholder = I18n.translate('js.modules.web_2018.feedback.comment_box_header_3');
      break;
      default:
        showCommentBox = false;
    }
    this.setState({ showCommentBox, commentBoxPlaceholder });
  }

  handleRatingChange() {
    document.querySelector('#feedback-form .feedback-form-bottom input[type="submit"]').disabled = false;
  }

  handleExitFromModal() {
    this.setFeedbackSubmitTime();
    if(this.props.openInNewTab) {
      window.open(this.props.navigatingToUrl);
      this.props.hideFeedbackModal();
    } else {
      window.location.href = this.props.navigatingToUrl;
    }
  }

  setFeedbackSubmitTime() {
    window.localStorage.setItem('customer-support-feedback-submit-time', Date.now())
  }

  handleCommentInput(commentText) {
    this.setState({ commentText })
  }

  saveFeedback() {
    let url = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/feedback`;
    let data = {
      comments: this.state.commentText,
      rating: document.querySelector('#feedback-form .rating input[name="rating"]:checked').value
    }
    SupportAPIHelper.call(url, 'POST', data, function(response) {}, function(err){}, false);
  }

  handleFormSubmit(e) {
    e.preventDefault();
    let rating = document.querySelector('#feedback-form .rating input[name="rating"]:checked').value;
    TrackingHub.add("CUSTOMER-FEEDBACK::feedback_form_sumbit", {rating: rating});
    this.saveFeedback();
    this.setFeedbackSubmitTime();
    this.props.showFeedbackSuccessWidget();
  }

  render() {
    const { showCommentBox, commentBoxPlaceholder } = this.state;
    return (
      <div class="feedback-form">
        <span class="close-modal icon-x" onClick={this.handleExitFromModal} data-bhw="CUSTOMER-FEEDBACK::feedback_form_exit" />
        <div class="cs-supporst-modal-title feedback-heading">{I18n.translate('js.modules.web_2018.feedback.heading')}</div>
        <form onSubmit={this.handleFormSubmit} id="feedback-form">
          <div class="rating" onChange={this.handleRatingChange}>
            <span>
              <input type="radio" name="rating" id="str1" value="1" onClick={this.showCommentBox} />
              <label data-bhw="CUSTOMER-FEEDBACK::feedback_form_rating_1" for="str1">
                <span class="rating-text">{I18n.translate('js.modules.web_2018.feedback.one')}</span>
                <div class="annotation">{I18n.translate('js.modules.web_2018.feedback.unhelpful')}</div>
              </label>
            </span>
            <span>
              <input type="radio" name="rating" id="str2" value="2" onClick={this.showCommentBox} />
              <label data-bhw="CUSTOMER-FEEDBACK::feedback_form_rating_2" for="str2">
                <span class="rating-text">{I18n.translate('js.modules.web_2018.feedback.two')}</span>
              </label>
            </span>
            <span>
              <input type="radio" name="rating" id="str3" value="3" onClick={this.showCommentBox} />
              <label data-bhw="CUSTOMER-FEEDBACK::feedback_form_rating_3" for="str3">
                <span class="rating-text">{I18n.translate('js.modules.web_2018.feedback.three')}</span>
              </label>
            </span>
            <span>
              <input type="radio" name="rating" id="str4" value="4" onClick={this.showCommentBox} />
              <label data-bhw="CUSTOMER-FEEDBACK::feedback_form_rating_4" for="str4">
                <span class="rating-text">{I18n.translate('js.modules.web_2018.feedback.four')}</span>
              </label>
            </span>
            <span>
              <input type="radio" name="rating" id="str5" value="5" onClick={this.showCommentBox} />
              <label data-bhw="CUSTOMER-FEEDBACK::feedback_form_rating_5" for="str5">
                <span class="rating-text">{I18n.translate('js.modules.web_2018.feedback.five')}</span>
                <div class="annotation rating-five">{I18n.translate('js.modules.web_2018.feedback.great')}</div>
              </label>
            </span>
          </div>
          { showCommentBox && <CommentBox onInput={this.handleCommentInput} title={commentBoxPlaceholder} /> }
          <div class="feedback-form-bottom">
            <input data-bhw="CUSTOMER-FEEDBACK::feedback_form_sumbit_bhw" type="submit" class="btn" disabled value={I18n.translate('js.modules.web_2018.feedback.submit')} />
          </div>
        </form>
      </div>
    )
  }
}

module.exports = FeedbackForm;